import { TaskCreatedDateFragment } from "gql/graphql";
import { DateAgoFormatter } from "@/shared/formatters";
import { Hidable, Value } from "@/shared/value";

/**
 * Когда задачу создали, относительно текущего момента: в уведомлениях и лентах важно
 * «сколько прошло», а не точная дата.
 */
export function TaskCreatedAgo({
  data,
}: {
  data?: Hidable<TaskCreatedDateFragment>;
}) {
  return (
    <Value data={data}>
      {(task) => <DateAgoFormatter value={task.createdDate} />}
    </Value>
  );
}
